module.exports = __webpack_public_path__ + "media/images/icon-abl-c2d40a84981bd79621aed42f9114ed11.png";